import { defineMessages } from 'react-intl';

export const customerMessages = defineMessages({
  loanDecisionSuccess: {
    id: 'loanDecision.notification.success',
    defaultMessage: 'La décision a été envoyée avec succès.',
  },
  loanDecisionError: {
    id: 'loanDecision.notification.error',
    defaultMessage: "Une erreur est survenue lors de l'envoi de la décision.",
  },
});
